import React from "react";

import {Badge} from "../../../../designSystem/components/Badge";
import {ACTION_MAPPING} from "../../../../utils/constants";
import {timestampToDate} from "../../../../utils/date";

interface AuditLogTableProps {
  sortedAuditLogs: any[];
  showJson: (e: React.MouseEvent, data: any) => void;
  moveJson: (e: React.MouseEvent) => void;
  hideJson: () => void;
};

export const AuditLogTable = ({
  sortedAuditLogs,
  showJson,
  moveJson,
  hideJson,
}: AuditLogTableProps) => (
  <table className='w-full table-fixed border shadow-lg rounded-2xl overflow-hidden'>
    <thead>
    <tr className='bg-white'>
      <th className='p-2 border cursor-pointer'>操作者ID</th>
      <th className='p-2 border cursor-pointer'>操作者姓名</th>
      <th className='p-2 border cursor-pointer w-[60px]'>動作</th>
      <th className='p-2 border cursor-pointer w-[180px]'>表單</th>
      <th className='p-2 border resize-x overflow-auto w-[90px]'>異動資料</th>
      <th className='p-2 border resize-x overflow-auto w-[200px]'>操作時間</th>
    </tr>
    </thead>

    <tbody>
    {sortedAuditLogs.map((auditLog) => (
      <tr key={auditLog.id} className='border bg-white'>
        <td className='p-2 border max-w-[170px] overflow-x-auto whitespace-nowrap'>
          <div className='text-sm'>{auditLog.userUid}</div>
        </td>

        <td className='p-2 border max-w-[170px] overflow-x-auto whitespace-nowrap'>
          <div className='text-sm'>{auditLog.userName}</div>
        </td>

        <td className='p-2 border'>
          <Badge tone='gray'>{ACTION_MAPPING[auditLog.action]}</Badge>
        </td>

        <td className='p-2 border'>
          <Badge tone='blue'>{auditLog.collectionName}</Badge>
        </td>

        <td
          className='p-2 border text-center'
          onMouseEnter={(e) => showJson(e, auditLog.data)}
          onMouseMove={moveJson}
          onMouseLeave={hideJson}
        >
          <i className="cursor-pointer fa fa-eye"></i>
        </td>

        <td className='p-2 border'>
          <div className='text-sm'>
            {new Date(timestampToDate(auditLog.createdAt)).toLocaleString()}
          </div>
        </td>
      </tr>
    ))}
    </tbody>
  </table>
);
